import { getSupportedFormatsWithParentheses } from '../getSupportedFormatsWithParentheses/getSupportedFormatsWithParentheses';

export const GENERIC_ERROR_MESSAGE = 'Something went wrong. Please contact customer support.';

export const INVALID_URL_MESSAGE = 'This URL is not a valid file URL';

export const checkUrl = async (url: string, accept: string[], maxSize: number) => {
	try {
		const response = await fetch(`/api/get-content-type?url=${encodeURIComponent(url)}`);

		if (!response.ok) {
			throw new Error(GENERIC_ERROR_MESSAGE);
		}

		const responseJson = await response.json();

		if (!responseJson?.contentType || !responseJson?.contentLength) {
			throw new Error(INVALID_URL_MESSAGE);
		}

		if (!accept.includes(responseJson?.contentType)) {
			throw new Error(
				`The file cannot be uploaded. Accepted file types are: ${getSupportedFormatsWithParentheses(
					accept
				)} only.`
			);
		}

		if (responseJson?.contentLength > maxSize) {
			throw new Error(
				`The file cannot be uploaded because it exceeds the size limit. Please ensure the file size is within the permissible range.`
			);
		}

		return '';
	} catch {
		throw new Error(INVALID_URL_MESSAGE);
	}
};
